// Core Module
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { BrowserAnimationsModule }               from '@angular/platform-browser/animations';
import { BrowserModule, Title }                  from '@angular/platform-browser';
import { AppRoutingModule }                      from './app-routing.module';
import { NgbModule }                             from '@ng-bootstrap/ng-bootstrap';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA }      from '@angular/core';
import { FormsModule, ReactiveFormsModule }      from '@angular/forms';
import { MatSortModule, MatTableModule }         from '@angular/material';
import {MatStepperModule}                        from '@angular/material/stepper';
import {MatIconModule}                           from '@angular/material/icon';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http'; 
import * as global                               from './config/globals';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

// Main Component
import { AppComponent }                    from './app.component';
import { HeaderComponent }                 from './components/header/header.component';
import { SidebarComponent }                from './components/sidebar/sidebar.component';
import { SidebarRightComponent }           from './components/sidebar-right/sidebar-right.component';
import { TopMenuComponent }                from './components/top-menu/top-menu.component';
import { FooterComponent }                 from './components/footer/footer.component';
import { PanelComponent }                  from './components/panel/panel.component';
import { FloatSubMenuComponent }           from './components/float-sub-menu/float-sub-menu.component';

import { AuthenticationGuard }             from './authentication/authentication.guard';
import {HttpHandlerInterceptor}            from './interceptors/http-handler.interceptors';
import {HttpService}                       from './interceptors/http-handler.services';

// Component Module
import { AgmCoreModule }                   from '@agm/core';
import { LoadingBarRouterModule }          from '@ngx-loading-bar/router';
import { NgxChartsModule }                 from '@swimlane/ngx-charts';
import { TrendModule }                     from 'ngx-trend';
import { CountdownModule }                 from 'ngx-countdown';
import { ChartsModule }                    from 'ng4-charts/ng4-charts';
import { TagInputModule }                  from 'ngx-chips';
import { SweetAlert2Module }               from '@sweetalert2/ngx-sweetalert2';
import { Ng2TableModule}                  from 'ngx-datatable/ng2-table';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { NvD3Module }                      from 'ng2-nvd3';
import { NgxDaterangepickerMd }            from 'ngx-daterangepicker-material';
//import 'd3';
//import 'nvd3';
import { CalendarModule, DateAdapter }     from 'angular-calendar';
import { adapterFactory }                  from 'angular-calendar/date-adapters/date-fns';
import { PerfectScrollbarModule }          from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG }        from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ReportViewerModule }              from 'ngx-ssrs-reportviewer';
import { QRCodeModule } from 'angularx-qrcode';
//import toastr
import { ToastrModule } from 'ngx-toastr';

import { BaseService } from './services/base.services';
import { AuthenticationService } from './authentication/authentication.service';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire';
import { NotificationsService } from './services/notifications.services';

// Pages
import { InitPage } from './pages/internal/init/init';
import { PollPage } from './pages/internal/poll/poll';


import { from } from 'rxjs';

import { NgSelectModule } from '@ng-select/ng-select';

//datetime picker
import { OwlMomentDateTimeModule } from 'ng-pick-datetime-moment';
import { DlDateTimeDateModule, DlDateTimePickerModule } from 'angular-bootstrap-datetimepicker';
import { OwlDateTimeModule, OwlNativeDateTimeModule,OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import { DashboardPage } from './pages/internal/dashboard/dashboard';
import { PageQR } from './pages/internal/page-qr/page-qr';
import { PageCheck } from './pages/internal/page-check/page-check';
import { ListTask } from './pages/task/list-task/list-task';
import { Login } from './pages/login/login';
import { AdminPage } from './pages/internal/admin/admin';
import { ChangePasswordPage } from './pages/change-password/change-password';
import { HomeTaskPage } from './pages/task/home/home';
import { MaintenancePage } from './pages/task/maintenance/maintenance';
import { ProductionPage } from './pages/task/production/production';
import { ActivityPage } from './pages/task/activity/activity';
import { StandardPage } from './pages/task/standard/standard';
import { environment } from '../environments/environment';
import { AsyncPipe } from '@angular/common';
import { FiltroPipe } from './pages/internal/pipes/filtro.pipe';
export const MY_MOMENT_FORMATS = {
  parseInput: 'DD/MM/YYYY HH:mm a',
  fullPickerInput: 'DD-MM-YYYY HH:mm ',
  datePickerInput: 'DD/MM/YYYY hh:mm a',
  timePickerInput: 'hh:mm a',
  monthYearLabel: 'MMM-YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM-YYYY',
};

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    SidebarRightComponent,
    TopMenuComponent,
    FooterComponent,
    PanelComponent,
    FloatSubMenuComponent,
    InitPage,
    PollPage,
    Login,
    PageQR,
    DashboardPage,
    AdminPage,
    PageCheck,
    ListTask,
    HomeTaskPage, 
    ChangePasswordPage,
    MaintenancePage,
    ProductionPage,
    ActivityPage,
    StandardPage,
    FiltroPipe
  ],
  imports: [
    AppRoutingModule,
    AgmCoreModule.forRoot({ apiKey: 'AIzaSyC5gJ5x8Yw7qP_DqvNq3IdZi2WUSiDjskk' }),
    BrowserAnimationsModule,
    BrowserModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    CountdownModule,
    ChartsModule,
    QRCodeModule,
    FormsModule,
    HttpClientModule,
    LoadingBarRouterModule,
    MatSortModule,
    MatTableModule,
    MatStepperModule,
    MatIconModule,
    NgbModule,
    NvD3Module,
    NgxChartsModule,
    Ng2TableModule,
    PaginationModule.forRoot(),
    NgxDaterangepickerMd.forRoot(),
    PerfectScrollbarModule,
    ReactiveFormsModule,
    SweetAlert2Module.forRoot(),
    TagInputModule,
    TrendModule,
    ReportViewerModule,
    ToastrModule.forRoot(),
    DlDateTimeDateModule, 
    DlDateTimePickerModule,
    OwlDateTimeModule, 
    OwlNativeDateTimeModule,
    OwlMomentDateTimeModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
    NgSelectModule
  ],
  providers: [ 
    Title, 
    BaseService,
    AuthenticationService,
    AuthenticationGuard,
    HttpHandlerInterceptor,
    NotificationsService,
    AsyncPipe,
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    {
      provide: HttpClient,
      useClass: HttpService
    },
    {
    provide: PERFECT_SCROLLBAR_CONFIG,
    useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    {provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS},
],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [ AppComponent ]
})

export class AppModule {
  constructor(private router: Router, private titleService: Title, private route: ActivatedRoute, private baseService: BaseService) {
    router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        console.log(e.url);
        
        var title = 'GIDC | ' + this.route.snapshot.firstChild.data['title'];
        this.titleService.setTitle(title);
      }
    });
  }



  async saveLog(url) {
    try {
//      await this.baseService.postLog(url).toPromise();
    }catch(error) {
      console.log(error);
    }
  }
}
